import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { IntegumentaryQuestionnaireItem } from './questionnaire'

export const INTEGUMENTARY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [IntegumentaryQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_SKIN_COLOR]:
    QuestionnaireAnswerType.STRING,
  [IntegumentaryQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_SKIN_ISSUES]:
    QuestionnaireAnswerType.STRING,
  [IntegumentaryQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_NAILS]:
    QuestionnaireAnswerType.STRING,
  [IntegumentaryQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_IDENTIFIED_WOUNDS]:
    QuestionnaireAnswerType.STRING,
  [IntegumentaryQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_WOUND_NOTES]:
    QuestionnaireAnswerType.STRING,
  [IntegumentaryQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING
}
